import { render, staticRenderFns } from "./PurchasesProfile.vue?vue&type=template&id=69bb2391&scoped=true"
import script from "./PurchasesProfile.vue?vue&type=script&lang=js"
export * from "./PurchasesProfile.vue?vue&type=script&lang=js"
import style0 from "./PurchasesProfile.vue?vue&type=style&index=0&id=69bb2391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb2391",
  null
  
)

export default component.exports